import {color, font, type} from "common/tokens";
import AttachFile from '@mui/icons-material/AttachFile';
import "components/styles/AgreeabilityScale.scss";
import { isEmpty } from 'lodash';
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const styles = {
  box: {
    ...type.body,
    backgroundColor: color.SURFACE,
    border: `1px solid ${color.BORDER}`,
    borderRadius: 12,
    color: color.TEXT,
    width: '100%',
    minHeight: 52,
    padding: '14px 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  documentBox: {
    ...type.body,
    borderRadius: 12,
    color: color.TEXT_MUTED,
    width: '100%',
    padding: '10px 16px',
    alignItems: 'center',
    display: 'flex',
  },
  // States the rule up front rather than only after a file is rejected.
  hint: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    margin: '8px 0 0',
    paddingLeft: 16,
  },
  error: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.DANGER,
    margin: '8px 0 0',
    paddingLeft: 16,
  },
  attachIcon: {
    color: color.TEXT_MUTED,
  },
};

const DocumentUpload = ({ onAnswered, value = [] }) => {
  const { t } = useTranslation();

  const [errorMessage, setErrorMessage] = useState("");
  const [documentName, setDocumentName] = useState("");

  const MAX_FILE_SIZE = 4000000;
  const ALLOWED_TYPE = "application/pdf";

  const handleUpload = (e) => {
    setErrorMessage("");
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    if (uploadedFile.type !== ALLOWED_TYPE || uploadedFile.size > MAX_FILE_SIZE) {
      setErrorMessage(t("uploadPdfRejected", {size: MAX_FILE_SIZE / 1000000}));
      return;
    }

    setDocumentName(uploadedFile.name);
    onAnswered(uploadedFile);
  };

  return (
    <div>
      <input
        type="file"
        onChange={handleUpload}
        id="upload"
        hidden
        accept="application/pdf"
      />
      <label htmlFor="upload" style={styles.box}>
        {t("uploadFile")}
      </label>

      {isEmpty(errorMessage)
        ? <p style={styles.hint}>{t("uploadPdfHint", {size: MAX_FILE_SIZE / 1000000})}</p>
        : <p style={styles.error}>{errorMessage}</p>}

      {!isEmpty(documentName) && (
        <label htmlFor="upload" style={styles.documentBox}>
          <AttachFile style={styles.attachIcon} />
          &nbsp;&nbsp;{documentName}
        </label>
      )}
    </div>
  );
};

export default DocumentUpload;
